import { RootState } from '../../app/state'

export const isAuthenticated = (state: RootState): boolean =>
  state.authentication.isAuthenticated
